import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { getReorderConflictIndex } from '@editor2/services/conflictResolutionService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { getParentEntityByPageId } from '@editor2/components/CourseChangesDiff/helpers';
import { filterByEntityId } from '../common/conflictResolutionHelper';
import { NgTraditional } from '@editor2/types/ngTraditional';

export class PageModifiedDeletedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const initialParent =
			getParentEntityByPageId(state.initialCourse.chapters, entityId) ||
			getParentEntityByPageId(state.initialCourse.page_groups, entityId);

		const filteredInitial = filterByEntityId(initialParent.pages, entityId);
		const parentId = initialParent.family_id;

		if (initialParent.type === NgTraditional.Chapter) {
			state.initialCourse.chapters.entities[parentId].pages = filteredInitial;
		} else if (initialParent.type === NgTraditional.PageGroup) {
			state.initialCourse.page_groups.entities[parentId].pages = filteredInitial;
		}
		state.changes.pages[conflict.entityId] = [ChangesStatus.New];

		// update page reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, parentId);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
		}
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const initialParent =
			getParentEntityByPageId(state.initialCourse.chapters, entityId) ||
			getParentEntityByPageId(state.initialCourse.page_groups, entityId);
		const currentParent =
			getParentEntityByPageId(state.chapters, entityId) ||
			getParentEntityByPageId(state.page_groups, entityId);

		const filteredInitial = filterByEntityId(initialParent.pages, entityId);
		const filteredCurrent = filterByEntityId(currentParent.pages, entityId);

		const parentId = initialParent.family_id;

		if (initialParent.type === NgTraditional.Chapter) {
			state.initialCourse.chapters.entities[parentId].pages = filteredInitial;
			state.chapters.entities[parentId].pages = filteredCurrent;
		} else if (initialParent.type === NgTraditional.PageGroup) {
			state.initialCourse.page_groups.entities[parentId].pages = filteredInitial;
			state.page_groups.entities[parentId].pages = filteredCurrent;
		}
		state.changes.pages[entityId] = [];

		// update page reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, parentId);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
			state.conflicts[reorderConflictIndex].current = filteredCurrent;
		}
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
